import React, { useState } from "react";
import { AppBar, Tabs, Tab, Divider } from "@material-ui/core";

import Shopify from "./Shopify";
import ContactUs from "./ContactUs";
import UsageIndicator from "components/shared/UsageIndicator";
import CommerceTabWrapper from "../styles/CommerceTabs.style";

function a11yProps(index) {
  return {
    id: `history-${index}`,
    className: "commerce__tab--button",
    "aria-controls": `shopify-tab-${index}`
  };
}

function CommerceTab(props) {
  const [activeTab, setActiveTab] = useState("shopify");
  const {
    addFavorite,
    additionalInfo,
    addToCart,
    auth,
    location,
    removeFavorite,
    removeFromCart,
    shopify,
    toggleDigitalTermsModal,
    user,
    video,
    isMobile
  } = props;
  const clearanceStatus = video?.clearanceStatus;
  const limitationVideo = clearanceStatus === "LIMITATIONS";

  return (
    <CommerceTabWrapper>
      <AppBar position="static" classes={{ root: "tab__commerce" }}>
        <Tabs
          value={activeTab}
          onChange={(_, value) => setActiveTab(value)}
          aria-label="Commerce Tabs"
        >
          <Tab value="shopify" label="Editorial Rights" {...a11yProps("shopify")} />
          <Tab
            value="advertising"
            label="Branded/Advertising Rights"
            {...a11yProps("advertising")}
          />
        </Tabs>
      </AppBar>

      {activeTab === "shopify" && (
        <div>
          {limitationVideo ? (
            <div>
              <div className="advertising">
                <p className="ads__usage">
                  For Digital Publishers Only <br />
                  i.e., fan engagement on social media, websites, and blogs, or for educational use
                </p>
                <p className="ads__requirements">
                  Some digital licenses require custom terms at this time. For more information,
                  inquire about licensing options.
                </p>
              </div>

              <ContactUs video={video} location={location} className="advertising" />
            </div>
          ) : (
            <Shopify
              addToCart={addToCart}
              removeFromCart={removeFromCart}
              user={user}
              auth={auth}
              video={video}
              addFavorite={addFavorite}
              removeFavorite={removeFavorite}
              additionalInfo={additionalInfo}
              toggleDigitalTermsModal={toggleDigitalTermsModal}
              shopify={shopify}
              location={location}
            />
          )}
        </div>
      )}

      {activeTab === "advertising" && (
        <div>
          <div className="advertising">
            <p className="ads__usage">For commercial use in TV, digital or other media.</p>
            <p className="ads__requirements">
              Commercial licenses require custom terms at this time. For more information, inquire
              about custom rights packages.
            </p>
          </div>

          <ContactUs video={video} location={location} className="advertising" />
        </div>
      )}

      <UsageIndicator video={video} />

      {activeTab === "advertising" && <Divider className="divider" />}
      {activeTab === "shopify" && !limitationVideo && (
        <div>
          <h3 className="custom-package">{isMobile && "Inquire for"} Custom Rights Package</h3>
          <ContactUs video={video} location={location} />
        </div>
      )}
    </CommerceTabWrapper>
  );
}

export default CommerceTab;
